module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "_idContainer010",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter Three")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("D")]), _vm._v("ane Gideon stepped through the barn door and switched on the overhead light. The remaining Holstein heifer could be inoculated and released into the pasture.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No problem. He would have it done before the boys came home from school.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not until he had the calf cornered in a stall did he recognize the little white bell on her otherwise black face. Too late, he heard the deep, rumbling moo of an angry mama cow behind him. Gordy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He should have waited.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She lowered her head and came at him, her huge nostrils snorting so forcefully her breath swept dust and particles of straw into a tiny cloud at her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane jumped up the side of a nearby stall, grabbed the ladder and climbed to the loft. He turned in time to see Starface skittering out of the barn ahead of her indignant mother.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Should’ve sold that ornery animal years ago,” he muttered, slowly descending the ladder.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gordy hurried after her baby, ears perked forward, her long, Holstein body all bulk and bones in the reflection of the afternoon sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane reached the barn floor in time to hear a loud whistle, followed by a “Yeehaw!” from outside.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He ran to the door to find Starface running back toward him, with Gordy in hot pursuit. He scrambled backward against a concrete stand, leaped atop it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another whistle pierced the gloom of the barn. Metal slapped wood—the slamming of the barn lot gate—then came another whistle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gordy waggled her head at Dane, big ears fluttering as she turned to investigate the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cook? Is that you?” Dane called.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A familiar, broad-shouldered form came striding inside, dreadlocks bouncing, thumbs hooked over the belt loops of his jeans. “Don’t you want to vaccinate Starface before—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Gavin, get back!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gordy lowered her head and charged as Gavin scrambled sideways. Dane jumped down and ran after the cow.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Gordy, over here!” He waved his arms over his head. “You old battleaxe, get away!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin leaped over the fence in one youthful motion.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gordy swerved and rammed Dane with her shoulder. He hit the ground as she swerved away, kicking out with her foot to land a solid blow to his left thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A loud grunt echoed in his head as he fell against the fence. The gate swung back and a hand grabbed his shirt, then jerked him, half dragging, half lifting him, out of the lot. As soon as he was clear, Gavin slammed the gate in the cow’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane slumped against the outside of the fence while Gavin shoved the gate latch home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You okay?” Gavin asked, bending over him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane gritted his teeth against the pain in his thigh. “I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry, I forgot Willy said Gordy had a mean streak.” Gavin gestured over his shoulder toward the cow and calf. “I know better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane caught sight of Gavin’s blood-streaked sleeve. “You’re bleeding.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin held his arm up and inspected a small cut at the base of his wrist. “I’ll get that taken care of. Guess that old cow hasn’t seen many black guys with locks like mine, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane rubbed his thigh. “I don’t think that had anything to do with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you want to vaccinate the calf while we’ve got her in the lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks, Gavin, but I think we’ll let them go this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When’re you going to start calling me Blaze?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When it becomes your legal name. What are you doing out of school early?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Last hour’s PE, and I didn’t have dress-out clothes, so I told the teacher I’d be good and come straight here if he let me leave early. Why do you have such a fuss with a silly ol’ nickname? Everybody else calls me Blaze.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good for them. We’ll find you some exercise clothes and shoes tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Guess you know I’ll be sixteen in three weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes. What do you want for your birthday?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“To quit school.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry, no way. Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’ll be legal then. A guy doesn’t have to go after his sixteenth birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He does if he plans to stay here at the ranch.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin blinked at Dane. “You mean I have to keep going to school just to stay here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s the deal. Gavin, you’re still bleeding.” An inch-long cut should have stopped bleeding by now, unless it was deeper than it appeared. The end of Gavin’s sleeve was soaked red.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The teenager pressed his fingers over the wound. “Nobody told me about that rule when I agreed to come here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You may find there are a lot of things around here nobody told you about.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin gave a disgusted grunt.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on,” Dane said. “Let’s get you to the house and clean your—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, fine, then there’s something else I want for my birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hope it’s Gordyburgers,” Dane muttered, still aching from the kick.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Call me by my chosen name.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane put a hand on Gavin’s shoulder and nudged him toward the house. “I don’t understand the logic of calling yourself Blaze when you aren’t an arsonist.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Something my daddy taught me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought he was a veterinarian.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin gave Dane an impatient look.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry. What did your father teach you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“To take the sting out of the name. Beat ’em to the punch.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did kids at school call you names?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s for me to know. Why’re you limping?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Gordy kicked me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Better get some ice on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I plan to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, you can say it. ‘I plan to, Blaze.’”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For three more weeks, your name is Gav or Gavin, take your pick.”")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("“Missouri Regional, this is 841, we are currently inbound for your facility....”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne glanced at her watch, groaned, straightened at her desk, still fighting the nausea. “Go away,” she muttered. Twenty more minutes, and Brillhart would be here. Why hadn’t she asked Ardis to call him sooner?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“...Caucasian female, late twenties, class one trauma from an MVA. Patient’s car was struck in the driver’s side, had to be extricated. Patient is fully immobilized, responsive only to pain. We are attempting to establish IV at this time. BP sixty over forty by—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Coming "), _c('i', [_vm._v("here?")]), _vm._v("” Ardis exclaimed. “Did you hear that? They’re bringing us a class one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne reached for the ambulance radio and keyed the microphone. “Eight-forty-one this is medical control. Divert to University Hospital. We are not a designated trauma facility.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Missouri Regional this is 841, we copy but cannot comply. University and Boone are both on full trauma diversion at this time. ETA of five minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne pressed the button again. “Eight-forty-one, this is medical control. We roger your last transmission. Please advise of any change in patient’s condition. This is medical control at Missouri Regional out.” She disconnected.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, my. What do we do now?” the secretary asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Advise RT and X Ray we’ve got a hot one coming in fast.” Cheyenne turned in her chair. “Quickly, Deanna.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“G-got it, Dr. Allison.” The secretary swallowed and jerked up the telephone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne nodded to Ardis. “Have Lab get four units of O-negative blood STAT. I want it in this department when the patient arrives. Then attempt to notify the surgeon on call for backup. Let him know what we have.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ardis went to work.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne found the intubation kit in the trauma room and selected the appropriate size ET tubes. What a time to have the flu.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The radio came alive again. “Missouri Regional, this is 841. Be advised our patient is now in full arrest. I repeat, our patient is in full arrest. Following ACLS protocol. ETA less than two minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne made eye contact with Ardis. They would do all they could, but the odds were against this patient surviving.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Everyone get your protective gear on,” Cheyenne said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hear the sirens now,” the secretary called.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Make sure RT and X Ray are on their way down,” Cheyenne said. “Ardis, check on that blood.” The trauma room was ready. “Aprons, masks, gloves, everyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Stepping to the window that overlooked the ambulance bay, Cheyenne caught sight of the red-orange-red-orange flash of lights as the van safety-sped into the lot. Tension thickened the air in the Emergency Department.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can do this,” she said. “Get ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The RT tech came racing down the far end of the corridor pushing her supply cart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ardis hung up the telephone and swung toward Cheyenne. “They’re getting the blood ready, Dr. Allison.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good. Come with me.” Cheyenne looked for the ER tech. “Rick, you too.” She led the way out to the bay, where the driver was yanking open the back doors of the ambulance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The attendants pulled the intubated patient from the vehicle. Cheyenne’s first sight of the patient was the flash of red blood marring a half-naked body—the attendants had stripped her to check for all injuries.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rick, take over compressions,” Cheyenne ordered the tech. “What’s the rhythm?” she asked the attendant, standing back as they wheeled the stretcher toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“PEA,” the paramedic said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pulseless electrical activity. No surprise, judging by the apparent blood loss. The patient was unrecognizable.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How much fluid have you given?” Cheyenne asked, following them through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ve only been able to give about a hundred cc’s,” the paramedic replied. “I could only get a twenty-two gauge IV started.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not big enough. “We need at least a twenty gauge.” She turned to Ardis. “I need you to establish a large-bore IV, have her ready for the blood when it arrives.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll get right on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They helped transfer the patient to the ER trauma bed while the respiratory tech took over bagging the patient, helping her breathe. Cheyenne moved to the patient’s left side to check for placement of the ET tube, leaving her right side accessible to Ardis.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No breath sounds over the abdomen. Good. That meant the patient had been intubated properly. Pressing the bell of the stethoscope over the patient’s bloody chest, she raised a hand for Rick to delay the next compression.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No heartbeat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded for him to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As she removed the stethoscope from the patient’s rib cage, she saw a dark blotch on the skin. A large birthmark just below the left breast.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked at the face again, reached for the blood-matted hair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Black. It was the length of...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked at the paramedic. “You said she was the driver?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Only person in the car. We pulled her from beneath the steering wheel.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne couldn’t catch her breath. “And the car? Did you notice what kind...?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dark blue Sable sedan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The edges of Cheyenne’s vision went black and she felt herself slipping backward. "), _c('i', [_vm._v("It can’t be—I told her not to drive, she said she wouldn’t....")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dr. Allison!” Ardis yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, Susan. Oh, please God, no.” Cheyenne fought to regain her composure. “Where’s that blood!” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right here,” Ardis said. “Hold on, Dr. Allison, I can’t get the large bore IV.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Have you heard from the surgeon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It couldn’t be Susan. She was only going to a neighbor’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But her sister’s silhouette—the undamaged part—was obvious now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Our on-call surgeon is also on trauma call for University,” Deanna said. “We’re trying to reach someone else, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ardis, get me a central line kit,” Cheyenne ordered. “She needs blood now. And get X Ray in here for a trauma series. Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dr. Allison?” came a voice from the hallway. It was her replacement. Jim Brillhart. His tall, lean form filled the doorway. “How can I help?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked up at him, felt the floor rock beneath her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He rushed forward and caught her arm. “Are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m getting ready to do a central line on this patient. I’ll take the jugular so I won’t interfere with CPR.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You want me to do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll be fine.” She refocused on her procedure, felt the sweat coat her neck and chest and trickle down the sides of her face as she tried to keep her hands steady")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A tech reported on the CBC and Cheyenne prepared for a transfusion as the respiratory tech came into the crowded room with a report on Susan’s blood gas that deepened Cheyenne’s frown.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That could be venous,” she said. "), _c('i', [_vm._v("They missed the artery and got a vein.")]), _vm._v(" “Take it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dr. Allison, I really don’t think it’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“One more time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The X-ray tech brought in the trauma X-ray series and mounted them on the view box.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It showed multiple left rib fractures with a massive collection of blood in the left chest cavity. Multiple pelvic fractures with a ground glass appearance on the X ray.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("No, Susan. No!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Get me a chest-tube setup. And wrap a sheet around her pelvis and tighten it as much as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick looked up from his compressions, though he continued in perfect rhythm. “You want me to stop doing compressions when you put in the chest tube?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, but no longer than absolutely necessary. Get somebody fresh to spell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let me do the chest tube,” Jim said, “then I’ll take over for Rick.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Check for fine V fib,” Cheyenne said as he placed the tube. "), _c('i', [_vm._v("Susan, baby, work with me. Don’t you dare die on me!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The monitor remained an agonal rhythm, but it now appeared more asystole.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Flatline.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No! She would not let that happen!")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’s that surgeon? I need him "), _c('i', [_vm._v("now.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, Dr. Allison, but he’s already been called to University Hospital for disaster code,” Deanna said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then it’s up to us,” Cheyenne said. “Get me a thoracotomy tray.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jim looked at her in surprise. “Cheyenne, are you sure about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Push the epinephrine, Ardis,” Cheyenne said, ignoring him. The thought of opening Susan’s chest and massaging her heart was unthinkable. But it was her sister’s only chance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ardis! Epi. Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dr. Allison,” Jim said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve got to try it,” she said softly. “This is my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave a shocked, “Oh, dear God no,” then, “Rick, take over back here.” Jim came around the bed to Cheyenne, placed a hand on each shoulder and tried to draw her away from the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She resisted. “I’m still the doctor in charge, Jim. You can’t take me off this case.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m your director, Cheyenne, and your friend. Listen to me for a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked up at him. “Did you hear me? It’s my "), _c('i', [_vm._v("sister!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know, but what if it weren’t? What would you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turned again to Susan’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s a blunt trauma victim, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s right, Dr. Brillhart,” said the paramedic.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pulseless for more than twenty minutes?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Twenty-five,” Rick said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cheyenne,” Jim said gently. “You need to let her go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t do that. Ardis, push the epinephrine again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ve done all you can,” Jim said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("No! I’m still in charge!")]), _vm._v(" “I haven’t called this code yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cheyenne.” Jim leaned closer. He placed a hand over hers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She jerked away. “Ardis, why are you waiting? Push the epi! Any word on the second blood gas?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dr. Allison,” Jim said, this time with authority. “You have to call it. She’s gone. She wouldn’t want to come back, even if she could. There’s too much damage.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne felt the dizziness strike once more with blinding swiftness. She couldn’t bear it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t call it,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll do it, then,” Jim said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Silence descended except for the sounds of the monitor, Rick’s labored breathing and the efforts that kept this hopelessly damaged body functioning.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Let her go? She’s already gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne looked at her watch, then reached for Susan’s hand, covered in blood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everyone waited.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("I’m so sorry, my baby sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Time of...” Cheyenne swallowed, took a breath of air, which was strong with the scent of blood. “Time of...death, 18:14.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick stopped compressions. The respiratory tech stopped bagging. Ardis set her equipment down and rushed around the bed to Cheyenne’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As Cheyenne felt herself falling, felt hands catching her, she willed herself to descend into death with her sister.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3ab9b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Three.vue
// module id = 84
// module chunks = 0